import api from "../axiosInstance";

export const getSocialMediaAPI = async () => {
  const response = await api.get(`/socialMedia`);
  return response;
};

// Post API for create social media
export const createSocialMediaDetailAPI = async (payload) => {
  const response = await api.post(`/socialMedia`, payload);
  return response;
};

export const deleteSocialMediaDetailAPI = async (payload) => {
  const response = await api.delete(`/socialMedia/${payload}`);
  return response;
};

export const editSocialMediaDetailAPI = async (payload) => {
  const response = await api.put(`/socialMedia/${payload.id}`, {
    name: payload.name,
    imageUrl: payload.imageUrl,
  });
  return response;
};
